import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

export type ResendEmailOtpVariables = {
  email: string;
  referral_code?: string;
};

function useResendOTP(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    ResendEmailOtpVariables
  >
) {
  const {
    isLoading: resendingOTP,
    isError: isResendError,
    error: resendError,
    mutate: resendOTP,
    reset,
  } = useMutation<APIResponse<any>, APIError, ResendEmailOtpVariables>(
    "resend_otp",
    async (variables) =>
      await post(API_URL + "/onboarding/users/onboarding/email", variables),
    {
      ...options,
    }
  );

  return {
    resendOTP,
    resendingOTP,
    isResendError,
    resendError,
    resetResend: reset,
  };
}

export default useResendOTP;
